module.exports = __webpack_public_path__ + "img/numbersAnalytics.34c6d7b6.png";